// Route guard for the admin area. On mount it asks the server who we are
// (cookie session). While that's pending it shows a spinner; if unauthenticated
// it redirects to the login page, preserving the attempted path so login can
// send the admin back where they were headed.
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { Box, CircularProgress } from '@mui/material';
import { fetchAdminMe } from '../../store/admin-auth-slice.js';

const RequireAdmin = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, checked } = useSelector((state) => state.adminAuth);

  useEffect(() => {
    if (!checked) dispatch(fetchAdminMe());
  }, [checked, dispatch]);

  if (!checked) {
    return (
      <Box sx={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh',
      }}
      >
        <CircularProgress aria-label="Checking your session" />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default RequireAdmin;
